import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { registerNewMailNotificationFilter } from 'owa-header-app-notifications';
import getSelectedFolder from 'owa-mail-store/lib/utils/getSelectedFolder';
export default function initializeNewMailNotificationFilter() {
    registerNewMailNotificationFilter(shouldSuppressNewMailNotification);
}
function shouldSuppressNewMailNotification() {
    var selectedFolder = getSelectedFolder();
    return !!selectedFolder && folderIdToName(selectedFolder.FolderId.Id) === 'inbox';
}
//# sourceMappingURL=initializeNewMailNotificationFilter.js.map